import React from "react";
import { Link } from "react-router-dom";

import { Button } from "react-bootstrap";
import queryString from "query-string";

const Page401 = (props: any) => {
  const { message } = queryString.parse(props.location.search);

  const DisplayMessage = () => {
    if (message) {
      return <span>{message}</span>;
    }
    return (
      <span>
        You are not authorized to access this page, ensure you are logged into the correct user for
        the content you are trying to reach
      </span>
    );
  };

  return (
    <div className="text-center">
      <h1 className="display-1 font-weight-bold">401</h1>

      <p className="h1">Unauthorized</p>

      <p className="h2 font-weight-normal mt-3 mb-4">
        <DisplayMessage />
      </p>

      <Link to="/">
        <Button color="primary" size="lg">
          Return to website
        </Button>
      </Link>
    </div>
  );
};

export default Page401;
